module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mlR6KW/images/cover.jpg?1684514921371",
      "alt": "This image is the cover for the book Reading Mark's Gospel as a Text from Collective Memory"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reading Mark's Gospel as a Text from Collective Memory\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("How did the Gospel of Mark come to exist? And how was the memory of Jesus shaped by the experiences of the earliest Christians? ")]), _c('p', [_vm._v("For centuries, biblical scholars examined texts as history, literature, theology, or even as story. Curiously absent, however, has been attention to processes of collective memory in the creation of biblical texts. ")]), _c('p', [_vm._v("Drawing on modern explorations of social memory, Sandra Huebenthal presents a model for reading biblical texts as collective memories. She demonstrates that the Gospel of Mark is a text evolving from collective narrative memory based on recollections of Jesus’s life and teachings. Huebenthal investigates the principles and structures of how groups remember and how their memory is structured and presented. In the case of Mark’s Gospel, this includes examining which image of Jesus, as well as which authorial "), _c('i', [_vm._v("self")]), _vm._v("-image, this text as memory constructs. "), _c('i', [_vm._v("Reading Mark’s Gospel as a Text from Collective Memory")]), _vm._v(" serves less as a key to unlock questions about the historical Jesus and more as an examination of memory about him within a particular community, providing a new and important framework for interpreting the earliest canonical gospel in context.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Huebenthal, Werner H. Kelber\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0